import { render, staticRenderFns } from "./CheckboxPlace.vue?vue&type=template&id=5104064a"
import script from "./CheckboxPlace.vue?vue&type=script&lang=js"
export * from "./CheckboxPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports